var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWirSindDeins({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Colored",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 228 68",
    style: {
      enableBackground: "new 0 0 228 68"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st1{fill:#FFFFFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "wirSindDeins") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "204.2,41.5 204.2,21 183.5,28.4 183.5,33.5 190.4,31 190.4,46.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196.3,9c-8.5,0-16.1,4.2-20.6,10.7l3.6,2.5c3.7-5.3,9.9-8.8,16.8-8.8c11.3,0,20.3,9.3,20.3,20.6 c0,11.3-9,20.6-20.3,20.6c-7,0-13.1-3.6-16.8-8.9l-3.7,2.6C180.2,54.8,187.6,59,196,59c13.9,0,25.1-11.2,25.1-25 C221.1,20.2,210.1,9,196.3,9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M164.6,22.4c-2.4,0-4.1,0-5.4,0.1c-0.8,0-1.4,0-2,0h-0.1v22.8l0.9,0c1.8,0,3.8,0.1,5.9,0.1 c7.9,0,12-4,12-11.7C175.9,26.4,172,22.4,164.6,22.4 M164.3,41.6c-0.9,0-2,0-2.6-0.1v-15c0.7,0,1.6-0.1,2.6-0.1 c4.6,0,6.8,2.5,6.8,7.7C171.1,39.2,168.9,41.6,164.3,41.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125.8,22.6L125.8,22.6l-5.8-0.1l-7.8,22.9h4.6l1.5-4.7h8.6l1.5,4.7h5.1L125.8,22.6z M119.6,36.9l2.2-7 c0.3-0.9,0.6-2,0.8-3c0.2,0.8,0.5,1.8,0.9,3l2.2,7H119.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.1,37.5c-0.3-0.6-0.8-1.2-1.1-1.7c2.9-1,4.6-3.3,4.6-6.5c0-4.6-2.9-7-8.3-7c-2.4,0-4.6,0-6.2,0.1 c-0.8,0-1.5,0-1.9,0h-0.1v22.9h4.6v-8.7h2.5l5.1,8.7h5.5L149.1,37.5z M140.9,26.4c0.4,0,1.5,0,3.3,0c2.5,0,3.7,1.1,3.7,3.3 c0,2.2-1.3,3.3-3.9,3.3h-3.1V26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.1,45.4h-2l-2.2-7.7c-0.2-0.6-0.3-1.2-0.4-1.8h0c-0.1,0.6-0.2,1.2-0.3,1.8L12,45.4h-2L6.9,33.8h1.7l2,7.6 c0.2,0.9,0.4,1.7,0.5,2.5h0c0.1-0.8,0.3-1.6,0.5-2.4l2.2-7.6h1.6l2.2,7.7c0.2,0.7,0.4,1.6,0.5,2.3h0c0.1-0.7,0.2-1.4,0.4-2.2 l2.1-7.9h1.6L19.1,45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.3,35.1c-0.6,0-1-0.4-1-1c0-0.6,0.5-1,1-1c0.6,0,1,0.4,1,1C25.4,34.7,24.9,35.1,24.3,35.1z M23.6,45.4 v-8.6h1.6v8.6H23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.8,38.2c-1.8-0.3-2.7,1-2.7,3.7v3.5h-1.6v-8.6H29c0,0.5-0.1,1.3-0.2,2h0c0.4-1.2,1.2-2.4,2.9-2.2 L31.8,38.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.7,38.1c-0.5-0.2-1.1-0.3-1.7-0.3c-1.1,0-1.7,0.4-1.7,1.2c0,1.9,4,0.9,4,3.9c0,1.4-1.2,2.6-3.5,2.6 c-0.7,0-1.5-0.1-2-0.2L36,44c0.6,0.2,1.3,0.4,2,0.4c1.2,0,1.8-0.5,1.8-1.3c0-1.9-4-0.9-4-3.9c0-1.4,1.1-2.5,3.4-2.5 c0.6,0,1.2,0.1,1.7,0.2L40.7,38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44,35.1c-0.6,0-1-0.4-1-1c0-0.6,0.5-1,1-1c0.6,0,1,0.4,1,1C45,34.7,44.5,35.1,44,35.1z M43.2,45.4v-8.6h1.6 v8.6H43.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.6,45.4v-5.5c0-1.2-0.3-1.9-1.5-1.9c-1.4,0-2.4,1.4-2.4,3.3v4.1h-1.6v-8.6h1.5c0,0.5,0,1.3-0.1,1.8h0 c0.5-1.2,1.6-2,3-2c1.9,0,2.6,1.2,2.6,2.8v6H52.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.8,45.4c0-0.5,0-1.2,0.1-1.7l0,0c-0.5,1.2-1.5,1.9-2.9,1.9c-2.1,0-3.2-1.5-3.2-4c0-3,1.7-4.8,4.5-4.8 c0.4,0,0.9,0,1.4,0.1v-4h1.5v12.6H61.8z M61.7,38.1c-0.5-0.1-1-0.2-1.5-0.2c-1.6,0-2.7,1-2.7,3.5c0,1.8,0.6,2.9,1.9,2.9 c1.5,0,2.4-1.6,2.4-3.4V38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.1,45.4c0-0.5,0-1.2,0.1-1.7l0,0c-0.5,1.2-1.5,1.9-2.9,1.9c-2.1,0-3.2-1.5-3.2-4c0-3,1.7-4.8,4.5-4.8 c0.4,0,0.9,0,1.4,0.1v-4h1.5v12.6H74.1z M74.1,38.1c-0.5-0.1-1-0.2-1.5-0.2c-1.6,0-2.7,1-2.7,3.5c0,1.8,0.6,2.9,1.9,2.9 c1.5,0,2.4-1.6,2.4-3.4V38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.3,45.1c-0.9,0.3-1.9,0.5-2.9,0.5c-2.6,0-4.1-1.4-4.1-4.4c0-2.6,1.4-4.5,3.9-4.5c2.4,0,3.4,1.6,3.4,3.5 c0,0.5-0.1,1-0.1,1h-5.6c0,2.1,0.8,3.1,2.6,3.1c0.8,0,1.7-0.2,2.5-0.5L84.3,45.1z M82.9,40.2c0-1.5-0.7-2.3-1.9-2.3 c-1.1,0-2,0.8-2.1,2.3H82.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.1,35.1c-0.6,0-1-0.4-1-1c0-0.6,0.5-1,1-1c0.6,0,1,0.4,1,1C88.1,34.7,87.6,35.1,87.1,35.1z M86.3,45.4 v-8.6h1.6v8.6H86.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.7,45.4v-5.5c0-1.2-0.3-1.9-1.5-1.9c-1.4,0-2.4,1.4-2.4,3.3v4.1h-1.6v-8.6h1.5c0,0.5,0,1.3-0.1,1.8h0 c0.5-1.2,1.6-2,3-2c1.9,0,2.6,1.2,2.6,2.8v6H95.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104,38.1c-0.5-0.2-1.1-0.3-1.7-0.3c-1.1,0-1.7,0.4-1.7,1.2c0,1.9,4,0.9,4,3.9c0,1.4-1.2,2.6-3.5,2.6 c-0.7,0-1.5-0.1-2-0.2l0.1-1.4c0.6,0.2,1.3,0.4,2,0.4c1.2,0,1.8-0.5,1.8-1.3c0-1.9-4-0.9-4-3.9c0-1.4,1.1-2.5,3.4-2.5 c0.6,0,1.2,0.1,1.7,0.2L104,38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.2,45.6c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1 C108.2,45.1,107.8,45.6,107.2,45.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWirSindDeins);
export default __webpack_public_path__ + "static/media/wirSindDeins.83dca676783fa7427afaa9bc8969f3f6.svg";
export { ForwardRef as ReactComponent };